<template>
  <div>
    <!-- View (card / Ver mais): cobre a MainNavBar, toolbar com altura fixa + X -->
    <div v-if="isCardView" class="notificacoes-dia-overlay">
      <v-toolbar dark color="header" height="64" flat class="notificacoes-dia-overlay__toolbar">
        <v-btn icon dark @click="closeCardView">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('operation.notificationsTitle') }}</v-toolbar-title>
      </v-toolbar>
      <div class="notificacoes-dia-overlay__body">
        <v-container fluid>
          <NotificacoesDiaTable
            :headers="headersWithProperties"
            :csv-headers="headers"
            :items="notificacoes"
            :export-items="exportItems"
            :default-multi-sort="defaultMultiSort"
            :loading="loading"
            :token="token"
            @update:displayedItems="displayedItems = $event"
            @tratar-todas="showResetDialog(null)"
            @tratar="showResetDialog"
            @mostrar-mapa="showMapa"
          />
        </v-container>
      </div>
    </div>

    <!-- Tela normal (menu / rota) -->
    <v-container v-else fluid class="notificacoes-dia-page pa-4">
      <NotificacoesDiaTable
        :headers="headersWithProperties"
        :csv-headers="headers"
        :items="notificacoes"
        :export-items="exportItems"
        :default-multi-sort="defaultMultiSort"
        :loading="loading"
        :token="token"
        @update:displayedItems="displayedItems = $event"
        @tratar-todas="showResetDialog(null)"
        @tratar="showResetDialog"
        @mostrar-mapa="showMapa"
      />
    </v-container>

    <v-dialog v-model="confirmResetDialog" persistent max-width="500" style="z-index: 10050">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('system.alert') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ mensagemResetDialog }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="confirmResetDialog = false">
            {{ $t('button.cancel') }}
          </v-btn>
          <v-btn color="red accent-4" class="white--text" @click="resetNotificacao">
            {{ $t('button.confirmOk') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMapa" fullscreen max-width="100%" style="z-index: 10060; background-color: white">
      <MapaNotificacao
        v-if="dialogMapa && itemMapaNotificacao"
        :item-mapa-notificacao="itemMapaNotificacao"
        :lat-notificacao="latNotificacao"
        :lng-notificacao="lngNotificacao"
        :dt-posicao-notificacao="dtPosicaoNotificacao"
        :item-endereco-import="itemEndereco"
        :user="user"
        :token="token"
        :bilhetagens="[]"
        :has_validador="showInfoValidador"
        @close="closeMapa"
      />
    </v-dialog>
  </div>
</template>

<script>
import apiController from "@/utils/apiController";
import DateUtils from "@/utils/dateutils";
import EventBus from "@/utils/eventBus";
import translateDbField from "@/utils/translateDbField";
import { mapGetters } from "vuex";
import NotificacoesDiaTable from "./NotificacoesDiaTable.vue";
import MapaNotificacao from "@/components/MapaNotificacao.vue";
import { NOTIFICACOES_DIA_SOURCE } from "@/utils/openNotificacoesDia";
import { notificacaoPertenceAoUsuario } from "@/utils/notificacaoVisibilidade";

export default {
  name: "NotificacoesDia",
  components: {
    NotificacoesDiaTable,
    MapaNotificacao,
  },
  data() {
    return {
      token: sessionStorage.getItem("api"),
      user: (() => {
        try {
          return JSON.parse(sessionStorage.getItem("user")) || {};
        } catch (e) {
          return {};
        }
      })(),
      loading: false,
      notificacoes: [],
      displayedItems: null,
      linhasIds: new Set(),
      empresasIds: new Set(),
      linhasLoaded: false,
      setup: { has_validador: 0 },
      confirmResetDialog: false,
      mensagemResetDialog: "",
      notifToReset: null,
      dialogMapa: false,
      itemMapaNotificacao: null,
      latNotificacao: null,
      lngNotificacao: null,
      dtPosicaoNotificacao: null,
      itemEndereco: {
        street: "",
        houseNumber: "",
        district: "",
        city: "",
        stateCode: "",
        postalCode: "",
      },
      defaultMultiSort: [
        { value: "hierarquia_notificacao", options: { value: 1 } },
        { value: "dt_notificacao_extenso", options: { value: -1 } },
      ],
    };
  },
  computed: {
    ...mapGetters("user", {
      is_superadmin: "super",
    }),
    isCardView() {
      const q = this.$route && this.$route.query;
      return Boolean(q && (q.from === NOTIFICACOES_DIA_SOURCE.CARD || q.from === "card"));
    },
    showInfoValidador() {
      return this.setup.has_validador === 1;
    },
    headers() {
      return [
        { text: this.$t("operation.notificationHeaders.id"), value: "id_notificacao", align: " d-none" },
        {
          text: this.$t("operation.notificationHeaders.hierarchy"),
          value: "hierarquia_notificacao",
          align: " d-none",
          filtrable: false,
        },
        { text: this.$t("operation.notificationHeaders.date"), value: "dt_notificacao_extenso" },
        { text: this.$t("operation.notificationHeaders.vehicleCode"), value: "cod_veiculo" },
        { text: this.$t("operation.notificationHeaders.equipment"), value: "nome_equipamento" },
        { text: this.$t("operation.notificationHeaders.type"), value: "descricao_tipo_notificacao" },
        { text: this.$t("operation.notificationHeaders.passengers"), value: "detalhe" },
        { text: this.$t("operation.notificationHeaders.area"), value: "nome_area" },
        { text: this.$t("operation.notificationHeaders.geofence"), value: "nome_cerca" },
        { text: this.$t("operation.notificationHeaders.line"), value: "nome_linha" },
        { text: this.$t("operation.notificationHeaders.treated"), value: "reset_extenso" },
        { text: this.$t("operation.notificationHeaders.address"), value: "tem_endereco" },
        { text: this.$t("operation.notificationHeaders.action"), value: "actions", sortable: false },
      ];
    },
    headersWithProperties() {
      return this.headers.map((header) => ({
        ...header,
        filtrable: header.filtrable !== false,
        sortable: header.sortable !== false,
      }));
    },
    exportItems() {
      return this.displayedItems !== null ? this.displayedItems : this.notificacoes;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.populaSetup();
      this.loadEscopoUsuario();
      this.populaNotificacoes();
    },
    closeCardView() {
      if (window.history.length > 1) {
        this.$router.go(-1);
        return;
      }
      this.$router.replace({ name: "Operacao" }).catch(() => {});
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        silent: true,
        onSuccess: (response) => {
          if (Array.isArray(response.data) && response.data[0]) {
            this.setup = Object.assign({}, response.data[0]);
          }
        },
      });
    },
    loadEscopoUsuario() {
      const idUsuario = this.user && this.user.id_usuario;
      const afterRecursos = (recursos) => {
        const list = Array.isArray(recursos) ? recursos : [];
        this.empresasIds = new Set(
          list
            .filter((r) => r && r.id_empresa != null)
            .map((r) => String(r.id_empresa))
        );
        this.loadLinhas();
      };

      if (this.is_superadmin) {
        apiController.request(apiController.endpoints.getallRecursos, {
          silent: true,
          onSuccess: (response) => afterRecursos(response.data),
          onError: () => {
            this.empresasIds = new Set();
            this.loadLinhas();
          },
        });
      } else if (idUsuario != null) {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: idUsuario },
          silent: true,
          onSuccess: (response) => afterRecursos(response.data),
          onError: () => {
            this.empresasIds = new Set();
            this.loadLinhas();
          },
        });
      } else {
        this.empresasIds = new Set();
        this.loadLinhas();
      }
    },
    loadLinhas() {
      apiController.request(apiController.endpoints.getLinhasoperacao, {
        silent: true,
        onSuccess: (response) => {
          const list = Array.isArray(response.data) ? response.data : [];
          this.linhasIds = new Set(list.map((l) => String(l.id_linha)));
          this.linhasLoaded = true;
          this.applyVisibilidadeFilter();
        },
        onError: () => {
          this.linhasIds = new Set();
          this.linhasLoaded = true;
          this.applyVisibilidadeFilter();
        },
      });
    },
    notifVisivel(n) {
      return notificacaoPertenceAoUsuario({
        notif: n,
        isSuperadmin: this.is_superadmin,
        idsLinhas: this.linhasIds,
        idsEmpresas: this.empresasIds,
      });
    },
    applyVisibilidadeFilter() {
      if (this.is_superadmin || !this.linhasLoaded || !Array.isArray(this.notificacoes)) {
        return;
      }
      this.notificacoes = this.notificacoes.filter((n) => this.notifVisivel(n));
    },
    populaNotificacoes() {
      this.loading = true;
      const dtinicio = new Date();
      dtinicio.setDate(dtinicio.getDate() - 1);
      const dti = DateUtils.getDateSQLFormatted(dtinicio);
      const dtf = DateUtils.getDateSQLFormatted(new Date());

      apiController.request(apiController.endpoints.getNotificacoespordata, {
        data: { dtinicio: dti, dtfim: dtf },
        onSuccess: (response) => {
          let list = Array.isArray(response.data) ? response.data : [];
          list = list.map((n) => ({
            ...n,
            descricao_tipo_notificacao: translateDbField(
              n.translation_key,
              n.descricao_tipo_notificacao
            ),
          }));
          if (!this.is_superadmin && this.linhasLoaded) {
            list = list.filter((n) => this.notifVisivel(n));
          }
          this.notificacoes = list;
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    showResetDialog(notif) {
      if (notif) {
        this.mensagemResetDialog = this.$t("operation.confirmReset");
        this.notifToReset = notif;
      } else {
        this.mensagemResetDialog = this.$t("operation.confirmResetAllNotifications");
        this.notifToReset = null;
      }
      this.confirmResetDialog = true;
    },
    resetNotificacao() {
      this.confirmResetDialog = false;
      if (this.notifToReset) {
        apiController.request(apiController.endpoints.updateNotificacao, {
          data: { id_notificacao: this.notifToReset.id_notificacao },
          silent: true,
          onSuccess: () => {
            this.notifToReset = null;
            EventBus.$emit("operacao-notificacoes-refresh");
            this.populaNotificacoes();
          },
          onError: (e) => {
            console.log("Response : " + (e && e.message));
            this.notifToReset = null;
          },
        });
        return;
      }

      const dtinicio = new Date();
      dtinicio.setDate(dtinicio.getDate() - 1);
      const dti = DateUtils.getDateSQLFormatted(dtinicio);
      const dtf = DateUtils.getDateSQLFormatted(new Date());
      apiController.request(apiController.endpoints.updateNotificacaoporperiodo, {
        data: { dtinicio: dti, dtfim: dtf },
        silent: true,
        onSuccess: () => {
          EventBus.$emit("operacao-notificacoes-refresh");
          this.populaNotificacoes();
        },
        onError: (e) => {
          console.log("Response : " + (e && e.message));
        },
      });
    },
    showMapa(item) {
      if (!item) {
        return;
      }
      const confirmed = this.$t("button.confirm");
      if (item.tem_endereco === confirmed || Number(item.tem_endereco) === 1) {
        this.itemEndereco = {
          street: item.rua || "",
          houseNumber: item.numero || "",
          district: item.bairro || "",
          city: item.cidade || "",
          stateCode: item.uf || "",
          postalCode: item.cep || "",
        };
      } else {
        this.itemEndereco = {
          street: "",
          houseNumber: "",
          district: "",
          city: "",
          stateCode: "",
          postalCode: "",
        };
      }
      this.itemMapaNotificacao = item;
      this.latNotificacao = item.lat;
      this.lngNotificacao = item.lng;
      this.dtPosicaoNotificacao = item.dt_ultima_posicao;
      this.dialogMapa = true;
    },
    closeMapa() {
      this.dialogMapa = false;
      this.itemMapaNotificacao = null;
    },
  },
};
</script>

<style scoped>
.notificacoes-dia-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: #fafafa;
  display: flex;
  flex-direction: column;
}

.notificacoes-dia-overlay__toolbar {
  flex: 0 0 64px !important;
  height: 64px !important;
  max-height: 64px !important;
  min-height: 64px !important;
}

.notificacoes-dia-overlay__toolbar >>> .v-toolbar__content {
  height: 64px !important;
}

.notificacoes-dia-overlay__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding-top: 8px;
}
</style>
